import { render, staticRenderFns } from "./StudentDiscounts.vue?vue&type=template&id=573625d9&scoped=true&"
import script from "./StudentDiscounts.vue?vue&type=script&lang=js&"
export * from "./StudentDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./StudentDiscounts.vue?vue&type=style&index=0&id=573625d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573625d9",
  null
  
)

export default component.exports